import { useEffect, useState } from "react"
import type { Course, CourseTargetObjetive } from "../entities/courses"
import useGetCourses from "../queries/use-get-courses"

export default function useCoursesInfo() {
  const [coursesInfo, setCoursesInfo] = useState<{ courses: Course[]; more: boolean }>({
    courses: [],
    more: false,
  })

  const { data, isLoading, isError, error, isSuccess, status, refetch, isFetching } =
    useGetCourses()

  useEffect(() => {
    if (data) {
      setCoursesInfo(data.data.description)
    }
  }, [data])

  const courseColors: { subjectId: string; color: string }[] = coursesInfo.courses.map(
    (course, index) => {
      const color = `var(--alternative-${index})`

      return {
        subjectId: course.subjectId,
        color: color,
      }
    },
  )

  const getCourseColor = (subjectId: string): string => {
    const courseColor = courseColors.find((course) => course.subjectId === subjectId)
    return courseColor ? courseColor.color : "#000000"
  }

  const updateCourseTargetObjective = (
    editedCourseId: string,
    newTargetObjective: CourseTargetObjetive,
  ) => {
    setCoursesInfo({
      ...coursesInfo,
      courses: coursesInfo.courses.map((course) => {
        if (course.id === editedCourseId) {
          return { ...course, targetObjective: newTargetObjective }
        }
        return course
      }),
    })
  }

  return {
    coursesInfo,
    courseColors,
    getCourseColor,
    isLoading,
    isError,
    error,
    isSuccess,
    status,
    refetch,
    isFetching,
    hasCourses: coursesInfo.courses.length > 0,
    updateCourseTargetObjective,
  }
}
